import { matchPath } from 'react-router'
import {URL_DATA} from './AppConfig'
import i18n from '../i18n'

/*
	Assemble the router information
	to a handy format. Do the matching
	from the pathname.
	The matches are not stored in redux
	
	This method needs to be called if there
	is a need to check the params		
*/

/**
 * Helper to generate match configuration and execute matchPath.
 */
const get_match = (type, pathname) => {
    return matchPath(
        { path: resolve_match_url(type), end: true, caseSensitive: false },
        pathname
    );
};

export const build_router_infos = (pathname) => {
    // Execute matches using the helper
    const line_match = get_match('line', pathname);
    const station_from_match = get_match('station_from', pathname);
    const station_from_to_match = get_match('station_from_to', pathname);
    const home_match = get_match('home', pathname);

    // Build the router_infos object
    let router_infos = {
        line_slug: line_match?.params.line_slug,
        from_slug: station_from_to_match?.params.from_slug || station_from_match?.params.from_slug,
        to_slug: station_from_to_match?.params.to_slug,
    };

    // Evaluate the type, now including the pathname for the "intern" check
    router_infos.type = get_router_type(home_match, router_infos, pathname);

    return router_infos;
};

/**
 * Evaluates the router type based on matched parameters and path content.
 */
const get_router_type = (home_match, router_infos, pathname) => {
    // Check for internal path first, needs refining if there are more "options" in the intern url
    if (pathname.includes('intern')) return 'intern';
    if (home_match !== null) return 'home';
    if (router_infos.line_slug !== undefined) return 'line';
    if (router_infos.from_slug !== undefined || router_infos.to_slug !== undefined) {
        return 'station';
    }
    return 'not_found';
};

/*
	return the match url for current
	or a specific language by id
*/
export const resolve_match_url = (id, language=undefined) => {
	let lang = i18n.language
	if(language !== undefined) {
		lang = language
	}
	const url = URL_DATA[lang]['match'][id]
	if(url === undefined) {
		throw SyntaxError('resolve_match_url: There is no url with id: '+id)
	}
	return url
}

/*
	return the url with filled params
	for the current language by id
*/
export const resolve_url = (id, params) => {
	const resolver_data = URL_DATA[i18n.language]['resolve'](params)
	const url = resolver_data[id]
	if(url === undefined) {
		throw SyntaxError('resolve_url: There is no url with id: '+id)
	}
	return url
}